import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BankAccountNumberService, OwnValidators } from 'projects/shared/src/public-api';
import { Bank } from '../../external-models/bank';
import { Branch } from '../../external-models/branch';
import { BankService } from '../../services/bank.service';

@Component({
  selector: 'account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss']
})
export class AccountDetailsComponent implements OnInit {

  private _accountDetails: FormGroup = new FormGroup({
    bank: new FormControl(null, [Validators.required]),
    branch: new FormControl(null, [Validators.required]),
    account: new FormControl("",
      {
        validators: [Validators.required, Validators.minLength(4), Validators.maxLength(12), Validators.pattern(/[0-9]+/)],
        asyncValidators: [this.bankAccountNumberService.asyncAccountNumberValidator],
        updateOn: 'blur'
      })

  });
  @Input() public get accountDetails(): FormGroup {
    return this._accountDetails;
  }
  public set accountDetails(form: FormGroup) {
    this._accountDetails = form;
    this.addRequierdIfOneFilledValidation();
  }

  @Input() selectedBankId: number = null;
  @Input() selectedBranchId: number = null;
  @Input() requiredIfOneFilled: boolean = false;

  private _onlyFeezBackBanks: boolean = false;

  @Input() public get onlyFeezBackBanks(): boolean {
    return this._onlyFeezBackBanks;
  }
  public set onlyFeezBackBanks(v: boolean) {
    this._onlyFeezBackBanks = v;
    this.setValidatorsAndValue();
  }

  private _isRequired: boolean = true;

  @Input() public get isRequired(): boolean {
    return this._isRequired;
  }
  public set isRequired(v: boolean) {
    this._isRequired = v;
    this.setValidatorsAndValue();
  }
  @Input() showClear: boolean = true;



  banks: Bank[];
  selectedBank: Bank;
  branches: Branch[];
  selectedBranch: Branch;
  bankBranches: Branch[];
  isUpdateValidations = 0;
  // tabPressed = false;

   @ViewChild("bank") bank: any;
  // @ViewChild("branch") branch: any;
  // @ViewChild('accountNumberInput') accountNumberInput: ElementRef;

  //מזהה אם המשתמש הגיע לשדה באמצעות מקש 
  // Tab,
  // כדי לפתוח את הדרופדאון אוטומטית
  // @HostListener('document:keydown', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   this.tabPressed = event.key === 'Tab';
  // }

  constructor(private bankService: BankService,
    private bankAccountNumberService: BankAccountNumberService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (!this.accountDetails.controls.hasOwnProperty("bank"))
      this.initFormGroup();
    this.getBanks();
    this.getBranches();
  }

  ngAfterViewInit() {
    this.removeClass();
  }

  // מאזין להקלדה בפילטר של 
  // dropdown
  // אם מוקלדים X תווים (כמו 2 לבנק או 3 לסניף) → נבחרת האפשרות אם קיימת
  // לאחר מכן → focus או show לשדה הבא
//   setupDropdownAutoSelect(
//     dropdownRef: any,
//     triggerLength: number,
//     nextElement: any,
//     modelProperty: 'selectedBank' | 'selectedBranch' | string
//   ) {
//     setTimeout(() => {
//       if (this.tabPressed && !dropdownRef.overlayVisible) {
//         dropdownRef.show();
//         this.tabPressed = false;
//       }

//       const filterInput = document.querySelector('.p-dropdown-filter') as HTMLInputElement;
//       if (!filterInput) return;

//       filterInput.focus();

//       const trySelect = (forceNext = false) => {
//         const inputVal = filterInput.value.trim().toLowerCase();
//         const match = dropdownRef.options.find((opt: any) => {
//           const value = (opt.value || '').toString().toLowerCase();
//           return value.startsWith(inputVal);
//         });

//         if (match) {
//           this[modelProperty] = match;
//           dropdownRef.formControl?.setValue(match);
//           dropdownRef.onChange.emit({ value: match });
//           dropdownRef.hide();

//           setTimeout(() => {
//             nextElement?.show?.() ||
//               nextElement?.focus?.() ||
//               nextElement?.nativeElement?.focus?.();
//           }, 100);
//         } else if (forceNext) {
//           dropdownRef.hide(); // סגירת הדרופדאון
//           setTimeout(() => {
//             nextElement?.focus?.() || nextElement?.nativeElement?.focus?.();
//           }, 100);
//         }
//       };

//       filterInput.oninput = () => {
//         if (filterInput.value.trim().length === triggerLength) trySelect();
//       };

// filterInput.onkeydown = (event: KeyboardEvent) => {
//   if (event.key === 'Enter') {
//     trySelect(true);
//     event.preventDefault();
//   }
//   else if (event.key === 'Tab') {
//     if (event.shiftKey) {
//       // Shift+Tab → לא מונעים מעבר שדה, רק סוגרים את הדרופדאון
//       dropdownRef.hide();
//     } else {
//       trySelect(true);
//       event.preventDefault();
//     }
//   }
// };
//     }, 100);
//   }

  // onBankFocusWrapper() {
  //   this.delayedSetup(this.bank, 2, () => this.branch, 'selectedBank');
  // }


  // // כשיש *ngIf (כמו בשדה סניף), הרפרנס #branch לא קיים ברגע הקריאה
  // // פונקציה זו מנסה שוב ושוב עד שהוא נטען, ואז מפעילה את setupDropdownAutoSelect
  // delayedSetup(
  //   dropdownRef: any,
  //   triggerLength: number,
  //   nextRefGetter: () => any,
  //   modelProperty: string,
  //   retries = 5
  // ) {
  //   const next = nextRefGetter();
  //   if (next) {
  //     this.setupDropdownAutoSelect(dropdownRef, triggerLength, next, modelProperty);
  //   } else if (retries > 0) {
  //     setTimeout(() => {
  //       this.delayedSetup(dropdownRef, triggerLength, nextRefGetter, modelProperty, retries - 1);
  //     }, 100);
  //   }
  // }





  removeClass() {
    this.bank?.el?.nativeElement.classList.remove('ng-dirty');
  }

  initFormGroup() {
    if (!this.accountDetails)
      this.accountDetails = new FormGroup({});

    this.accountDetails.addControl("bank", new FormControl(null, this._isRequired ? [Validators.required] : []));
    this.accountDetails.addControl("branch", new FormControl(null, this._isRequired ? [Validators.required] : []));
    this.accountDetails.addControl("account", new FormControl("",
      this._isRequired ? {
        validators: [Validators.required, Validators.minLength(4), Validators.maxLength(12), Validators.pattern(/[0-9]+/)],
        asyncValidators: [this.bankAccountNumberService.asyncAccountNumberValidator],
        updateOn: 'blur'
      } : {}));
    this.updateValidation();

  }

  setValidatorsAndValue() {
    let bankValidators = [];
    let branchValidators = [];
    if (this._isRequired) {
      bankValidators.push(Validators.required);
      branchValidators.push(Validators.required);
    }
    if (this.onlyFeezBackBanks) {
      bankValidators.push(OwnValidators.feezbackbankValidator);
      branchValidators.push(OwnValidators.feezbackBranchValidator);
    }

    this.accountDetails.setControl("bank", new FormControl(this.accountDetails.controls.bank?.value, bankValidators));
    this.accountDetails.controls['bank']?.updateValueAndValidity();

    this.accountDetails.setControl("branch", new FormControl(this.accountDetails.controls.branch?.value, branchValidators));
    this.accountDetails.controls['branch']?.updateValueAndValidity();

    this.accountDetails.setControl("account", new FormControl(this.accountDetails.controls['account']?.value,
      this._isRequired ? {
        validators: [Validators.required, Validators.minLength(4), Validators.maxLength(12), Validators.pattern(/[0-9]+/)],
        asyncValidators: [this.bankAccountNumberService.asyncAccountNumberValidator],
        updateOn: 'blur'
      } : {}));
    this.accountDetails.controls['account']?.updateValueAndValidity();
    this.accountDetails.updateValueAndValidity();
  }


  getBanks() {
    this.bankService.getBanksList().subscribe(res => {
      this.banks = res as Bank[];
      this.selectedBank = this.banks.find(x => x.id == this.selectedBankId);
      this.updateValidation();
      this.cdr.detectChanges();
      this.filterBranches();
    });


  }

  getBranches() {
    this.bankService.getBranchesList().subscribe(res => {
      this.branches = res as Branch[];
      this.cdr.detectChanges();
      this.filterBranches();
    });
  }

  filterBranches() {
    if (this.branches && this.selectedBank) {
      this.bankBranches = this.branches.filter(x => x.bankId == this.selectedBank.id);
      this.selectedBranch = this.bankBranches.find(x => x.id == this.selectedBranchId);
      this.updateValidation();
      this.cdr.detectChanges();
    }
  }

  addRequierdIfOneFilledValidation() {
    this.accountDetails.get('bank')?.valueChanges.subscribe(value => {
      this.updateValidation();
    });

    this.accountDetails.get('branch')?.valueChanges.subscribe(value => {
      this.updateValidation();
    });

    this.accountDetails.get('account')?.valueChanges.subscribe(value => {
      this.updateValidation();
    });
    this.updateValidation();
  }

  updateValidation() {
    if (this.requiredIfOneFilled) {
      const bank = this.accountDetails.get('bank');
      const branch = this.accountDetails.get('branch');
      const account = this.accountDetails.get('account');
      if (bank.value || bank.value || account.value) {
        bank.setValidators([Validators.required]);
        branch.setValidators([Validators.required]);
        account.setValidators([Validators.required]);
      } else {
        bank.setValidators([Validators.nullValidator]);
        branch.setValidators([Validators.nullValidator]);
        account.setValidators([Validators.nullValidator]);
      }

      bank.updateValueAndValidity();
      branch.updateValueAndValidity();
      account.updateValueAndValidity();
      this.isUpdateValidations++;
    }
  }
}
